module.exports = __webpack_public_path__ + "static/media/profileSq.ab439da6.jpg";